module.exports = __webpack_public_path__ + "img/Jump Casting114.398dbb71.jpg";